document.addEventListener('DOMContentLoaded', function () {

  const select = document.getElementById('chapter-jump');

  if (!select) return;

  select.addEventListener('change', function () {

    if (this.value) {
      window.location.href = this.value;
    }

  });

});